<template>
  <span>
    <v-menu>
      <v-btn
        slot="activator"
        class="ma-0"
        color="grey--text text--darken-1"
        icon
      >
        <v-icon
          class="hoverable-icon"
          medium
          v-text="icon"
        />
      </v-btn>
      <v-list>
        <v-list-tile class="mt-1">
          <v-list-tile-content>
            <v-list-tile-sub-title
              style="
                max-width: 400px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              <v-icon
                color="msr"
                small
              > location_on </v-icon>
              {{ device.store.city }}, {{ device.store.name
              }}<span v-if="device.store.location">
                ({{ device.store.location }})
              </span>
            </v-list-tile-sub-title>
            <v-list-tile-title
              class="ml-1 title mt-1 grey--text text--darken-3"
            >
              {{ device.description }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mt-2" />
        <!-- Go to detail page -->
        <v-list-tile
          v-if="device.ctype != 'visitorcount_sensor'"
          @click="
            $router.push({
              name: 'decoder',
              params: {
                ctype: device.ctype,
                decoderId: device.id,
              },
            })
          "
        >
          <v-list-tile-action>
            <v-icon>arrow_back</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('goToDecoderDetailPage') }}
          </v-list-tile-title>
        </v-list-tile>
        <!-- Rename Decoder -->
        <v-list-tile
          v-if="device.ctype != 'visitorcount_sensor'"
          @click="startRenamingDecoder()"
        >
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('renameDecoder') }}
          </v-list-tile-title>
        </v-list-tile>
        <!-- Copy MAC: LAN -->
        <v-list-tile
          v-if="device.mac"
          @click="copyAttributeFromDecoderToClipboard(device, 'mac')"
        >
          <v-list-tile-action>
            <v-icon>content_copy</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('copy') }}: <b>MAC (LAN)</b>
          </v-list-tile-title>
        </v-list-tile>
        <!-- Copy MAC: WIFI -->
        <v-list-tile
          v-if="device.wifimac"
          @click="copyAttributeFromDecoderToClipboard(device, 'wifimac')"
        >
          <v-list-tile-action>
            <v-icon>content_copy</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t('copy') }}: <b>MAC (WIFI)</b>
          </v-list-tile-title>
        </v-list-tile>
        <!-- Copy IP -->
        <v-list-tile
          v-if="device.ip"
          @click="copyAttributeFromDecoderToClipboard(device, 'ip')"
        >
          <v-list-tile-action>
            <v-icon>content_copy</v-icon>
          </v-list-tile-action>
          <v-list-tile-title> {{ $t('copy') }}: <b>IP</b> </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <!-- Rename Decoder Dialog -->
    <v-dialog
      v-model="showRenameDecoderDialog"
      persistent
      lazy
      :width="360"
    >
      <v-card>
        <v-card-title class="pb-0">
          <div class="headline">
            {{ $t('renameDecoder') }}
          </div>
          <v-btn
            class="ml-auto mr-0 my-0"
            flat
            icon
            :title="$t('close')"
            @click="abortRenamingDecoder()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-text-field
            ref="decoderDescriptionInput"
            v-model="newDecoderDescription"
            :counter="decoderDescriptionMaximum"
            :rules="[
              decoderDescriptionRules.min,
              decoderDescriptionRules.max,
              decoderDescriptionRules.unique,
            ]"
            class="mb-1"
            autofocus
            data-cy="rename-decoder-input"
            @keyup.esc="abortRenamingDecoder()"
            @keyup.enter="onRenamedDecoderSubmitted()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <btn-ok
            data-cy="rename-decoder-confirm-btn"
            :disabled="!renameFormIsValid"
            :loading="renaming"
            round
            @click="onRenamedDecoderSubmitted()"
          />
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import {capitalize, copyToClipboard} from '@/utils';

import renameDecoder from '@/mixins/renameDecoder.js';

import BtnOk from '@/components/ButtonOk';

export default {
  components: {
    BtnOk,
  },
  mixins: [renameDecoder],
  props: {
    device: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: 'more_vert',
    },
  },
  computed: {
    /** Compatibility alias for the renameDecoder mixin. */
    decoder() {
      return this.device;
    },
  },
  methods: {
    copyAttributeFromDecoderToClipboard(decoder, attribute) {
      const vm = this;

      function callback() {
        vm.$bus.$emit('alert-info', {
          message: capitalize(vm.$t('copied')) + ': ' + decoder[attribute],
          translate: false,
          timeout: 1000,
        });
      }
      copyToClipboard(decoder[attribute], (callback = callback));
    },
    onRenamedDecoderSubmitted() {
      if (!this.renameFormIsValid) {
        return;
      }

      const vm = this;
      function onSuccess() {
        vm.$emit('renamed');
      }

      this.updateDecoderDescription(
        this.decoder.ctype,
        this.decoder.id,
        this.newDecoderDescription,
        onSuccess
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceActions.vue